import NotificationsLink from './NotificationsLink';

export default NotificationsLink;
